import { render, staticRenderFns } from "./CouponIssueIframe.vue?vue&type=template&id=876399a2&"
import script from "./CouponIssueIframe.vue?vue&type=script&lang=ts&"
export * from "./CouponIssueIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports